
import {
  ExerciseModuleMap,
  ExerciseMutations,
} from "@/store/modules/exercise/types";
import ShareSvgVue from "../components/svg/ShareSvg.vue";
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { StoreState } from "@/store/types";
import { namespaceName } from "@/store/createStore";
import { canShareContent } from "@/helpers/helpers";

const exerciseStateProps = ["holdTimes", "numberOfRounds"] as const;

type ComputedTypes = ExerciseModuleMap<typeof exerciseStateProps>;

export default defineComponent({
  name: "BreathingExercise-Summary",
  components: {
    appShareSvg: ShareSvgVue,
  },

  props: {
    fromRecovery: Boolean,
  },

  data() {
    return {
      canShare: canShareContent(),
      copiedResults: false,
    };
  },
  computed: {
    ...(mapState<StoreState>("exercise", exerciseStateProps) as ComputedTypes),
    averageTime() {
      if (this.holdTimes.length === 0) {
        return "0";
      }

      return (this.holdTimes.reduce((pv, v) => pv + v) / this.holdTimes.length)
        .toFixed(3)
        .replace(/((\.0+)|(0+))$/g, "");
    },
  },

  watch: {
    copiedResults() {
      (this.$refs.shareBtn as HTMLButtonElement).classList.remove("animation");
      void (this.$refs.shareBtn as HTMLButtonElement).offsetWidth;
      (this.$refs.shareBtn as HTMLButtonElement).classList.add("animation");
    },
  },

  methods: {
    share() {
      let text = "";
      this.holdTimes.forEach((v, idx) => {
        if (idx > 0) {
          text += "\n";
        }
        text += `Round ${idx + 1}:\t${v} s`;
      });

      if (this.holdTimes.length > 1) {
        text += `\n\nAverage time: ${this.averageTime} seconds.`;
      }
      if (navigator.share) {
        navigator
          .share({
            url: "/",
            title: "Breathing Exercise Results",
            text,
          })
          .catch((err: Error) => {
            console.log("sharing failed", err);
          });
      } else {
        console.info(
          "Sharing API is not available in your browser. We will copy your results to clipboard."
        );
        const url = document.location.protocol + "//" + document.location.host;
        text = "Breathing Exercise Results\n\n" + text;
        text += "\n\nTry yourself on " + url;

        navigator.clipboard
          .writeText(text)
          .then(() => {
            this.copiedResults = !this.copiedResults;
          })
          .catch((err: Error) => {
            console.log("Could not insert text to your clipboard due to:", err);
            console.log("You may copy it from below:\n");
            console.log(text);
          });
      }
    },
  },

  mounted() {
    this.$store.commit(namespaceName("exercise", ExerciseMutations.Finish));
  },
});
